import { capitalizeFirstLetter } from '@shared/utils/capitalizeFirstLetter';

import type { DetailInfoType, FolderType } from '@pages/organizer/Cloud/store/cloud-store/cloud-types';
import type { Nullable } from '@shared/types/base-custom.type';

export const detailsFolderData = (data: FolderType): Nullable<DetailInfoType> => {
  if (!data) return null;

  return {
    name: data.folder.name,
    size: data.folder.size,
    url: '',
    type: data.type,
    formatter_type: data.folder.is_system ? 'System Folder' : capitalizeFirstLetter(data.type),
    created_at: data.folder.created_at,
    location: data.folder.location,
    item: data.folder.item,
    hub: data.folder.hub,
    is_system: data.folder.is_system,
    owner_id: data.folder.owner_id,
    ownerName: 'Me',
    id: data.id,
    hub_name: data.folder.hub_name,
  };
};
